import { getFormFieldConfig, getSubFormFieldConfig, modifiedObjectAsConfig } from "../utils/Config/getDefaultConfig";
import { generateObjectId } from "../utils/objectIdUtils";
import { toastError } from "../utils/toastUtils";

export const getMAppedAndModifiedFormField = (type, fields) => {
  const obj = {};
  fields.forEach((field) => {
    const newField = returnModifiedObjectAsConfig(field, type);
    if (field.type === "container" || field.type === "recordset" || field.type === "recordset-list") {
      const components = field.components.map((containerField) => {
        return returnModifiedObjectAsConfig(containerField, type);
      });
      newField.components = components;
    }
    obj[field.id] = newField;
  });
  return obj;
};

export const returnModifiedObjectAsConfig = (field, type) => {
  if (type === "subform") {
    return modifiedObjectAsConfig(field, getSubFormFieldConfig(field.type));
  } else {
    return modifiedObjectAsConfig(field, getFormFieldConfig(field.type));
  }
};

export const getGridsOfFormFields = (fields) => {
  const gridArray = fields.map((field, i) => {
    return {
      w: 12,
      h:
        field.type === "container" || field.type === "recordset" || field.type === "recordset-list"
          ? field.components.length + 1
          : 1,
      x: 0,
      y: i,
      i: field.id
    };
  });
  return gridArray;
};

export const getGridLayoutForDesktop = (fields, desktopLayout = {}) => {
  const grid = {
    outer_layout: []
  };
  grid.outer_layout = adjustGridForFields(fields || [], desktopLayout["outer_layout"] || []);
  fields?.forEach((field) => {
    if (
      field.type === "container" ||
      field.type === "recordset" ||
      field.type === "recordset-list" ||
      (field.type === "global-data" &&
        field.global_field.field_type &&
        field.global_field.field_type === "recordset-list")
    ) {
      const arr = adjustGridForFields(field.components || [], desktopLayout[field.id] || []);
      grid[field.id] = arr;
    }
  });
  return grid;
};

const adjustGridForFields = (fields, grid) => {
  if (!Array.isArray(fields) || !Array.isArray(grid)) {
    toastError("Fields and grid must be arrays.");
  }

  const newGrid = [];
  const fieldIds = fields.map((field) => field.id);

  fieldIds.forEach((id) => {
    const gridItem = grid.find((item) => item.i === id);
    if (gridItem) {
      newGrid.push(gridItem);
    }
  });
  fields.forEach((field) => {
    if (!newGrid.some((item) => item.i === field.id)) {
      newGrid.push({
        h:
          field.type === "container" ||
          field.type === "recordset" ||
          field.type === "recordset-list" ||
          (field.type === "global-data" &&
            field.global_field.field_type &&
            field.global_field.field_type === "recordset-list")
            ? field.components?.length + 1
            : 1,
        i: field.id,
        w: 12,
        x: 0,
        y: newGrid.length
      });
    }
  });

  if (newGrid.length > fields.length) {
    newGrid.splice(fields.length);
  }

  return newGrid;
};

export const convertAiFromDataToActualData = (data) => {
  const newArray = [];
  data.forEach((field) => {
    const singleField = getFormFieldConfig(field.type);
    let obj = {};
    if (field.options) {
      obj = {
        ...singleField,
        ...field,
        key: field.type + "_" + (Math.floor(Math.random() * 900000) + 100000),
        id: generateObjectId(),
        data: { ...singleField.data, values: field.options }
      };
    } else {
      obj = {
        ...singleField,
        ...field,
        id: generateObjectId(),
        key: field.type + "_" + (Math.floor(Math.random() * 900000) + 100000)
      };
    }
    delete obj["options"];
    newArray.push(obj);
  });
  return newArray;
};

export const processAiSmConfigForFormFields = (smConfig) => {
  if (!smConfig?.activities) return smConfig;

  const newActivities = smConfig.activities.map((activity) => {
    if (!activity?.form?.sections?.[0]?.fields) return activity;

    return {
      ...activity,
      form: {
        ...activity.form,
        sections: [
          {
            ...activity.form.sections[0],
            fields: convertAiFromDataToActualData(activity.form.sections[0].fields)
          }
        ]
      }
    };
  });

  return { ...smConfig, activities: newActivities };
};
